import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import LANGUAGES from "../constants/Languages";
import React from "react";
import {useTranslation} from "react-i18next";

const LanguageSelect = ({currentLang, changeLang}) => {
    const {t} = useTranslation();

    return <FormControl sx={{m: 1, minWidth: 120}} size="small">
        <InputLabel id="lang-input-label">{t("language")}</InputLabel>
        <Select
            labelId="lang-select-label"
            id="lang-select"
            label="Language"
            value={currentLang.code}
            onChange={changeLang}
        >
            {LANGUAGES.map(({code, name, emoji}) =>
                <MenuItem key={code} value={code} disabled={code === currentLang.code}>
                    {`${emoji} ${name}`}
                </MenuItem>
            )}
        </Select>
    </FormControl>
}

export default LanguageSelect;